module.exports = __webpack_public_path__ + "static/Kelvin Gani-a446037cb49f9e6548d28db8f8971f2c.jpeg";